export { getVerticalAlignment } from "./getTextAlignmentValue";
export { getHorizontalAlignment } from "./getTextAlignmentValue";
export { getHeadingAlignment } from "./getTextAlignmentValue";

export type { TextAlignmentType } from "./types";
export type { GradientType } from "./types";
export type { JustifyType } from "./types";
export type { AlignType } from "./types";
